import { Heart } from 'lucide-react';
import { tchOr } from './tchOr';

/*
 * Texas Children's Cardiac rotation. Blackboard has no cardiac folder, so this rotation
 * carries the General OR tools and its own notes until the cardiac team provides content.
 * See docs/review-tch.md.
 */

export const tchCardiac = {
  accent: tchOr.accent,
  icon: Heart,
  tagline: 'Cardiac ORs. Content to come from the cardiac team',
  notesKey: 'notes:texas-childrens:cardiac',
};
